import { $, $$ } from '../_utils'
import EventBus from '../_event-bus'

const SEPARATORS = {
  vimeo: '/',
  youtube: '=',
}

class LightBox {
  constructor($lightbox) {
    this.$$lightbox = $lightbox
    this.$open = $$('.open-lightbox-button')
    this.$close = $('.js-lightbox__close', this.$$lightbox)
    this.$fade = $('.js-lightbox__fade', this.$$lightbox)
    this.$player = null
    this.clickedLink = {}
    this.videoUrl = null // current
    this.nextUrl = null
    this.playerState = {
      htmlPlayer: false,
      youTubePlayer: false,
      vimeoPlayer: false,
    }
  }

  getVideoId = playerType => {
    const table = this.videoUrl.split(SEPARATORS[playerType])
    return table[table.length - 1]
  }

  getScreenWidth = () => {
    this.windowWidth = window.innerWidth
  }

  onWidhtChange = () => {
    EventBus.$on('resize', this.resizePlayer)
  }

  resizePlayer = () => {
    this.getScreenWidth()
    if (this.windowWidth <= 768 && this.playerState.vimeoPlayer) {
      $('iframe', this.$$lightbox).setAttribute('width', this.windowWidth)
      $('iframe', this.$$lightbox).setAttribute('height', this.windowWidth)
    }

    if (this.windowWidth > 768 && this.playerState.vimeoPlayer) {
      $('iframe', this.$$lightbox).setAttribute('width', '1000')
      $('iframe', this.$$lightbox).setAttribute('height', '500')
    }
  }

  onYouTubeIframeAPIReady = () => {
    // eslint-disable-next-line no-undef
    this.$player = new YT.Player('player', {
      height: '500',
      width: '1000',
      videoId: this.getVideoId('youtube'),
    })
    this.playerState.youTubePlayer = true
    this.prevVideoUrl = this.videoUrl
  }

  destroyHtmlPlayer = () => {
    $('video', this.$$lightbox).remove()
    this.playerState.htmlPlayer = false
  }

  destroyYouTubePlayer = () => {
    this.$player.destroy()
    this.playerState.youTubePlayer = false
  }

  destroyVimeoPlayer = () => {
    this.$player.destroy()
    this.playerState.vimeoPlayer = false
  }

  createHtmlPlayer = () => {
    const template = `<video class="js-lightbox__player" id="VisaChipCardVideo" width="100%" height="100%" controls>
    <source src="${this.videoUrl}" type="video/mp4"></video>`

    document.querySelector('.js-lightbox__wrapper').insertAdjacentHTML('afterBegin', template)
    this.$player = $('.js-lightbox__player', this.$$lightbox)

    this.prevVideoUrl = this.videoUrl
    this.playerState.htmlPlayer = true
  }

  createVimeoPlayer = async () => {
    const { default: Player } = await import(/* webpackChunkName: "vimeo-player" */ '@vimeo/player')

    this.$player = new Player('player', {
      id: this.getVideoId('vimeo'),
      width: '1000',
      height: '500',
      loop: false,
    })
    this.playerState.vimeoPlayer = true
  }

  manageYouTubePlayer = () => {
    if (!this.playerState.youTubePlayer) {
      if (this.playerState.htmlPlayer) this.destroyHtmlPlayer()
      if (this.playerState.vimeoPlayer) this.destroyVimeoPlayer()
      this.onYouTubeIframeAPIReady()
    } else if (this.playerState.youTubePlayer && this.videoUrl !== this.prevVideoUrl) {
      this.$player.cueVideoById(this.getVideoId('youtube'))
      this.playerState.youTubePlayer = true
      this.prevVideoUrl = this.videoUrl
    }
  }

  manageHTMLVideoPlayer = () => {
    if (!this.playerState.htmlPlayer) {
      if (this.playerState.youTubePlayer) {
        this.destroyYouTubePlayer()
      }
      if (this.playerState.vimeoPlayer) {
        this.destroyVimeoPlayer()
      }
      this.createHtmlPlayer()
      this.resizePlayer()
    } else if (this.playerState.htmlPlayer) {
      if (this.videoUrl === this.prevVideoUrl) return
      const source = $('source', this.$$lightbox)
      source.setAttribute('src', this.videoUrl)
      this.prevVideoUrl = this.videoUrl
    }
  }

  manageVimeoPlayer = () => {
    if (!this.playerState.vimeoPlayer) {
      if (this.playerState.youTubePlayer) this.destroyYouTubePlayer()
      if (this.playerState.htmlPlayer) this.destroyHtmlPlayer()
      this.createVimeoPlayer()
      this.$player.ready().then(() => this.resizePlayer())
    } else if (this.playerState.vimeoPlayer) {
      this.$player.unload()
      this.$player.loadVideo(this.getVideoId('vimeo'))
      this.prevVideoUrl = this.videoUrl
    }
  }

  chooseThePlayer = () => {
    if (!this.videoUrl.includes('youtube.com') && !this.videoUrl.includes('vimeo.com')) {
      this.manageHTMLVideoPlayer()
    } else if (this.videoUrl.includes('youtube.com')) {
      this.manageYouTubePlayer()
    } else {
      this.manageVimeoPlayer()
    }
  }

  handleOpen = () => {
    this.$open.forEach(item => {
      // add event listener

      item.addEventListener('click', event => {
        event.preventDefault()

        // get video url

        // this.nextUrl = item.getAttribute('href')
        // this.checkUrlAdress()
        this.videoUrl = item.getAttribute('href')

        // setup clickedLink

        this.clickedLink = item

        // load proper player

        this.chooseThePlayer()

        // open modal

        this.manageOpenClass('open', item)
      })
    })
  }

  manageOpenClass = action => {
    if (action === 'open') {
      if (!this.$$lightbox.className.includes('open')) {
        this.$$lightbox.classList.add('js-lightbox--open')
        this.clickedLink.classList.add('open')
      }
    } else if (this.$$lightbox.className.includes('open')) {
      this.$$lightbox.classList.remove('js-lightbox--open')
      this.clickedLink.classList.remove('open')
    }
  }

  stopVideo = () => {
    if (!this.$player) return
    if (this.playerState.htmlPlayer) {
      this.$player.pause()
      this.$player.currentTime = 0
    } else if (this.playerState.youTubePlayer) {
      this.$player.pauseVideo()
    } else {
      this.$player.pause()
    }
  }

  handleClose = () => {
    this.$close.addEventListener('click', () => {
      this.manageOpenClass('remove')
      this.stopVideo()
    })
    this.$fade.addEventListener('click', () => {
      this.manageOpenClass('remove')
      this.stopVideo()
    })
  }

  init() {
    this.handleOpen()
    this.handleClose()
    this.onWidhtChange()
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const $$lightboxes = $$('.js-lightbox')
  if (!$$lightboxes.length || !$$('.open-lightbox-button').length) return
  $$lightboxes.forEach($lightbox => {
    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    const lightbox = new LightBox($lightbox)
    lightbox.init()
  })
})
